import script from "./MenuBadgeDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuBadgeDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./MenuBadgeDisplay.vue?vue&type=style&index=0&id=093aea74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093aea74"]])

export default __exports__